export const DividerDisplayBlock = () => {
  return <hr />
}
